import React from 'react';
import { IconButton } from '@mui/material';
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import { useTranslation } from 'react-i18next';

export const HelpCentre = () => {
    const { t, i18n } = useTranslation();

    const supportUrl = `https://support.parkit.cloud/hc/${i18n.language}`;

    return (
        <a href={supportUrl} target="_blank" rel="noreferrer">
            <IconButton
                aria-label={t("general.helpCentre")}
                title={t("general.helpCentre")}>
                <HelpCenterOutlinedIcon />
            </IconButton>
        </a>
    );
};
